import { render, staticRenderFns } from "./productdetail.vue?vue&type=template&id=acde0916&scoped=true&"
import script from "./productdetail.vue?vue&type=script&lang=js&"
export * from "./productdetail.vue?vue&type=script&lang=js&"
import style0 from "./productdetail.vue?vue&type=style&index=0&id=acde0916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acde0916",
  null
  
)

export default component.exports